<h3 mat-dialog-title>Invite people to your company via</h3>

<mat-dialog-content>
  <mat-tab-group [selectedIndex]="selectedTab" mat-align-tabs="center">
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="mr-1">email_outline</mat-icon>
        Email
      </ng-template>

      <div class="mt-2">
        <checkd-autocomplete-emails (emailInvitesChanged)="updateEmailInvites($event)"></checkd-autocomplete-emails>
      </div>
    </mat-tab>
  </mat-tab-group>

  <!-- Role selection -->
  <div class="role-selection" style="margin-top: 1rem">
    <label>Select role: </label>
    <mat-radio-group [(ngModel)]="selectedRole" aria-label="Select role" style="display: flex; gap: 12px" (change)="updateSelectedRole()">
      <mat-radio-button value="DEFAULT"><strong>Normal Rights</strong></mat-radio-button>
      <mat-radio-button value="ADMINISTRATOR"><strong>Admin Rights</strong></mat-radio-button>
    </mat-radio-group>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button primary-button [type]="'outline'" mat-dialog-close>Close</button>
  <button primary-button [disabled]="!canSendInvites" (click)="sendInvites()">
    {{ inviteButtonMessage }}
  </button>
</mat-dialog-actions>
